module.exports = __webpack_public_path__ + "media/images/sp/plans/search_form/location_type_location_sola@2x-5d8966c243283c899b6abf2acee33452.webp";